import { colorSet, theme } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';

interface UseStylesProps {
  matches?: boolean;
  isPagination?: boolean;
}

const useStyles = makeStyles<Theme, UseStylesProps>(() => {
  return {
    container: {
      padding: ({ matches }) => (matches ? '0px' : '32px 24px')
    },
    root: {
      position: 'relative',
      width: '100%',
      height: (props) => (props.matches ? '100%' : 360),
      borderTop: (props) =>
        props.matches ? 'none' : `1px solid ${colorSet.gray400}`,
      borderRight: (props) =>
        props.matches ? 'none' : `1px solid ${colorSet.gray400}`,
      borderLeft: (props) =>
        props.matches ? 'none' : `1px solid ${colorSet.gray400}`,
      borderRadius: (props) => (props.matches ? 0 : '16px 16px 0px 0px'),
      overflow: 'hidden'
    },
    fileName: {
      background: colorSet.gray000 + 'E5',
      color: colorSet.gray900,
      position: 'absolute',
      top: 16,
      left: 16,
      zIndex: 2,
      opacity: 0.8,
      borderRadius: 8,
      boxShadow: `0 0 0 1px ${colorSet.gray400} inset`,
      padding: '6px 12px 8px',
      width: 470,
      [theme.breakpoints.down('md')]: {
        width: 440
      }
    },
    swiperWrapper: {
      position: 'relative',
      height: '100%',
      '& .swiper-container': {
        width: '100%',
        height: '100%',
        padding: 0,
        borderRadius: (props) => (props.matches ? 0 : '16px 16px 0 0'),
        minHeight: 240
      },
      '& .swiper-pagination-fraction': {
        boxShadow: `0 0 0 1px ${colorSet.gray400} inset`,
        backgroundColor: colorSet.gray000 + 'E5',
        opacity: 0.8,
        color: colorSet.gray900,
        width: 'fit-content',
        borderRadius: 8,
        display: (props) => (props.isPagination ? 'flex' : 'none'),
        alignItems: 'center',
        padding: '6px 12px 8px',
        fontSize: 13,
        top: 54,
        left: 16,
        bottom: 'unset'
      }
    },
    swiperBtn: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      transform: 'translateY(-50%)',
      top: '50%',
      zIndex: 1000,
      width: 26,
      height: 26,
      borderRadius: '50%',
      backgroundColor: colorSet.gray000,
      boxShadow: theme.shadows[1],
      cursor: 'pointer'
    },
    swiperPrevBtn: {
      left: 16
    },
    swiperNextBtn: {
      right: 16
    },
    viewerBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: 48,
      marginTop: 'auto',
      borderBottom: (props) =>
        props.matches ? `1px solid ${colorSet.gray400}` : 'none',

      '& button': {
        borderTop: `1px solid ${colorSet.gray200}`,
        backgroundColor: colorSet.gray100,
        width: '100%',
        borderRight: (props) =>
          props.matches ? 'none' : `1px solid ${colorSet.gray400}`,
        borderLeft: (props) =>
          props.matches ? 'none' : `1px solid ${colorSet.gray400}`,
        borderBottom: (props) =>
          props.matches ? 'none' : `1px solid ${colorSet.gray400}`,
        borderRadius: (props) => (props.matches ? 0 : '0px 0px 16px 16px'),
        '&:hover': {
          backgorundColor: colorSet.gray100
        }
      }
    }
  };
});

export default useStyles;
